import {useEffect} from 'react'
import theme from '../themes/pTheme/pTheme'
import {changeLabelColorOnEditToggle} from './common/markerHelpers'

export const useChangeLabelColorOnUnmount = (chartRef) => {
  useEffect(() => {
    return () => {
      if (chartRef.current?.options.plugins.marker.editEnabled) {
        changeLabelColorOnEditToggle(chartRef.current, theme.palette.hpBaseDark)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        chartRef.current.update()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
export const useToggleModeEnabled = (chartRef, setIsAnyModeEnabled) => {
  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.setIsAnyModeEnabled = setIsAnyModeEnabled
      setIsAnyModeEnabled(
        chartRef.current?.options?.plugins.marker.editEnabled || chartRef.current?.options?.plugins.marker.enabled
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
